
//Jacket
let jacket1N = "https://i8.amplience.net/i/jpl/jd_668644_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let jacket2N = "https://i8.amplience.net/i/jpl/jd_668543_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let jacket3N = "https://i8.amplience.net/i/jpl/jd_646704_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let jacket4J = "https://i8.amplience.net/i/jpl/jd_620153_d?qlt=92&w=750&h=957&v=1&fmt=auto"
let jacket5J = "https://i8.amplience.net/i/jpl/jd_620137_d?qlt=92&w=750&h=957&v=1&fmt=auto"
let jacket6A = "https://i8.amplience.net/i/jpl/jd_644003_b?qlt=92&w=750&h=957&v=1&fmt=auto"
//T-shirts
let Tshirts1A = "https://i8.amplience.net/i/jpl/jd_644647_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts2A = "https://i8.amplience.net/i/jpl/jd_644182_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts3A = "https://i8.amplience.net/i/jpl/jd_678388_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts4A = "https://i8.amplience.net/i/jpl/jd_656484_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts5C = "https://i8.amplience.net/i/jpl/jd_657249_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts6C = "https://i8.amplience.net/i/jpl/jd_657241_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts7H = "https://i8.amplience.net/i/jpl/jd_665987_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts8H = "https://i8.amplience.net/i/jpl/jd_634576_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let Tshirts9H = "https://i8.amplience.net/i/jpl/jd_634595_a?qlt=92&w=750&h=957&v=1&fmt=auto"
//Pnats
let pants1N = "https://i8.amplience.net/i/jpl/jd_668559_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants2N = "https://i8.amplience.net/i/jpl/jd_668542_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants3N = "https://i8.amplience.net/i/jpl/jd_668528_f?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants4L = "https://i8.amplience.net/i/jpl/jd_615541_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants5L = "https://i8.amplience.net/i/jpl/jd_615474_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants6P = "https://i8.amplience.net/i/jpl/jd_628146_e?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants7P = "https://i8.amplience.net/i/jpl/jd_655139_e?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants8C = "https://i8.amplience.net/i/jpl/jd_639561_a?qlt=92&w=750&h=957&v=1&fmt=auto"
let pants9C = "https://i8.amplience.net/i/jpl/jd_639563_a?qlt=92&w=750&h=957&v=1&fmt=auto"
// Shoes
let shoes1T = "https://i8.amplience.net/i/jpl/jd_636658_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes2T = "https://i8.amplience.net/i/jpl/jd_636662_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes3A = "https://i8.amplience.net/i/jpl/jd_652962_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes4A = "https://i8.amplience.net/i/jpl/jd_677839_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes5A = "https://i8.amplience.net/i/jpl/jd_618190_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes6C = "https://i8.amplience.net/i/jpl/jd_660681_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes7C = "https://i8.amplience.net/i/jpl/jd_660680_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes8B = "https://i8.amplience.net/i/jpl/jd_633042_a?qlt=92&w=750&h=531&v=1&fmt=auto"
let shoes9B = "https://i8.amplience.net/i/jpl/jd_633036_a?qlt=92&w=750&h=531&v=1&fmt=auto"



let arr = [[{
    jackets: {

        1: {

        }
    }
}],]

export const products = [
    // Start Jacket


    {
        id: 1,
        price: 230,
        rating: 5,
        title: "Nike Windrunner  Jacket",
        reviews: "548",
        image: jacket1N,
        inStock: true,
        color: "grey",
        brand: "Nike",
        category: "Jackets",
        quantity: 1,
    },


    {
        id: 2,
        price: 230,
        rating: 5,
        title: "Nike Air Max Woven Jacket",
        reviews: "548",
        image: jacket2N,
        inStock: true,
        color: "brown",
        brand: "Nike",
        category: "Jackets",
        quantity: 1,

    },
    {
        id: 3,
        price: 230,
        rating: 5,
        title: "Nike Hybrid Windrunner Jacket",
        reviews: "548",
        image: jacket3N,
        inStock: true,
        color: "white",
        brand: "Nike",
        category: "Jackets",
        quantity: 1,

    },
    {
        id: 4,
        price: 230,
        rating: 5,
        title: "Jordan Flight MVP Woven Jacket",
        reviews: "548",
        image: jacket4J,
        inStock: true,
        color: "black",
        brand: "Jordan",
        category: "Jackets",
        quantity: 1,


    },
    {
        id: 5,
        price: 230,
        rating: 5,
        title: "Jordan Essential Woven Jacket",
        reviews: "548",
        image: jacket5J,
        inStock: true,
        color: "red",
        brand: "Jordan",
        category: "Jackets",
        quantity: 1,

    },
    {
        id: 6,
        price: 230,
        rating: 5,
        title: "adidas Originals SST Track Top",
        reviews: "548",
        image: jacket3N,
        inStock: true,
        color: "white",
        brand: "Adidas",
        category: "Jackets",
        quantity: 1,


    },




    // End Jacket
    // Start T-shirts 
    {
        id: 7,
        price: 230,
        rating: 5,
        title: "adidas Badge T-Shirt",
        reviews: "548",
        image: Tshirts1A,
        inStock: true,
        color: "Orange",
        brand: "Adidas",
        category: "T-shirts",
        quantity: 1,


    },
    {
        id: 8,
        price: 230,
        rating: 5,
        title: "adidas Badge T-Shirt",
        reviews: "548",
        image: Tshirts2A,
        inStock: true,
        color: "Black",
        brand: "Adidas",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 9,
        price: 230,
        rating: 5,
        title: "adidas Badge of Sport T-Shirt",
        reviews: "548",
        image: Tshirts3A,
        inStock: true,
        color: "Blue",
        brand: "Adidas",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 10,
        price: 230,
        rating: 5,
        title: "adidas Summer Sticker  T-Shirt",
        reviews: "548",
        image: Tshirts4A,
        inStock: true,
        color: "Blue",
        brand: "Adidas",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 11,
        price: 230,
        rating: 5,
        title: "Castore Performance T-Shirt",
        reviews: "548",
        image: Tshirts5C,
        inStock: true,
        color: "white",
        brand: "Castore",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 12,
        price: 230,
        rating: 5,
        title: "Castore Mesh Mix T-Shirt",
        reviews: "548",
        image: Tshirts6C,
        inStock: true,
        color: "Blue",
        brand: "Castore",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 13,
        price: 230,
        rating: 5,
        title: "HUGO Tape T-Shirt",
        reviews: "548",
        image: Tshirts7H,
        inStock: true,
        color: "white",
        brand: "HUGO",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 14,
        price: 230,
        rating: 5,
        title: "HUGO Dalpaca Script T-Shirt",
        reviews: "548",
        image: Tshirts8H,
        inStock: true,
        color: "Blue",
        brand: "HUGO",
        category: "T-shirts",
        quantity: 1,

    },
    {
        id: 15,
        price: 230,
        rating: 5,
        title: "HUGO Dulivio 3D T-Shirt",
        reviews: "548",
        image: Tshirts9H,
        inStock: true,
        color: "Black",
        brand: "HUGO",
        category: "T-shirts",
        quantity: 1,

    },

    // End T-shirts 
    // Start Pants
    {
        id: 16,
        price: 230,
        rating: 5,
        title: "Nike Poly Knit Track Pants",
        reviews: "548",
        image: pants1N,
        inStock: true,
        color: "Grey",
        brand: "Nike",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 17,
        price: 230,
        rating: 5,
        title: "Nike Air Max Woven Pants",
        reviews: "548",
        image: pants2N,
        inStock: true,
        color: "Black",
        brand: "Nike",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 18,
        price: 230,
        rating: 5,
        title: "Nike Air Max Woven Pants",
        reviews: "548",
        image: pants3N,
        inStock: true,
        color: "Black",
        brand: "Nike",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 19,
        price: 230,
        rating: 5,
        title: "Lacoste Croc Joggers",
        reviews: "548",
        image: pants4L,
        inStock: true,
        color: "Grey",
        brand: "Lacoste",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 20,
        price: 230,
        rating: 5,
        title: "Lacoste Poly Track Pants",
        reviews: "548",
        image: pants5L,
        inStock: true,
        color: "Grey",
        brand: "Lacoste",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 21,
        price: 230,
        rating: 5,
        title: "Puma Tech Track Pants",
        reviews: "548",
        image: pants6P,
        inStock: true,
        color: "Blue",
        brand: "Puma",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 22,
        price: 230,
        rating: 5,
        title: "Puma Tech Track Pants",
        reviews: "548",
        image: pants7P,
        inStock: true,
        color: "Black",
        brand: "Puma",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 23,
        price: 230,
        rating: 5,
        title: "Castore Hybrid Woven Pants",
        reviews: "548",
        image: pants8C,
        inStock: true,
        color: "Blue",
        brand: "Castore",
        category: "Pants",
        quantity: 1,

    },
    {
        id: 24,
        price: 230,
        rating: 5,
        title: "Castore Hybrid Woven Pants",
        reviews: "548",
        image: pants9C,
        inStock: true,
        color: "Black",
        brand: "Castore",
        category: "Pants",
        quantity: 1,

    },


    // End Pants
    // Start Shoes 
    {
        id: 25,
        price: 230,
        rating: 5,
        title: "Tommy Hilfiger Tevo",
        reviews: "548",
        image: shoes1T,
        inStock: true,
        color: "Black",
        brand: "Tommy Hilfiger",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 26,
        price: 230,
        rating: 5,
        title: "Tommy Hilfiger Daniel",
        reviews: "548",
        image: shoes2T,
        inStock: true,
        color: "White",
        brand: "Tommy Hilfiger",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 27,
        price: 230,
        rating: 5,
        title: "Asics GEL-Quantum 360 7",
        reviews: "548",
        image: shoes3A,
        inStock: true,
        color: "Grey",
        brand: "Asics",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 28,
        price: 230,
        rating: 5,
        title: "Asics GEL-Quantum 360 7",
        reviews: "548",
        image: shoes4A,
        inStock: true,
        color: "Black",
        brand: "Asics",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 29,
        price: 230,
        rating: 5,
        title: "Asics GEL-NYC",
        reviews: "548",
        image: shoes5A,
        inStock: true,
        color: "Grey",
        brand: "Asics",
        category: "Shoes",
        quantity: 1,


    },
    {
        id: 30,
        price: 230,
        rating: 5,
        title: "Converse Chuck Taylor ",
        reviews: "548",
        image: shoes6C,
        inStock: true,
        color: "Black",
        brand: "Converse",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 31,
        price: 230,
        rating: 5,
        title: "Converse Chuck Taylor High",
        reviews: "548",
        image: shoes7C,
        inStock: true,
        color: "White",
        brand: "Converse",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 32,
        price: 230,
        rating: 5,
        title: "BOSS Titanium 2",
        reviews: "548",
        image: shoes8B,
        inStock: true,
        color: "Green",
        brand: "BOSS",
        category: "Shoes",
        quantity: 1,

    },
    {
        id: 33,
        price: 230,
        rating: 5,
        title: "BOSS Titaniums",
        reviews: "548",
        image: shoes9B,
        inStock: true,
        color: "Blue",
        brand: "BOSS",
        category: "Shoes",
        quantity: 1,

    },

    // End Shoes 

]




